export default "__VITE_ASSET__DRTUo$h7__"